export default {
  "root": "_root_rbg7a_1",
  "list": "_list_rbg7a_1",
  "inner": "_inner_rbg7a_1",
  "listItem": "_listItem_rbg7a_1",
  "button": "_button_rbg7a_1",
  "buttonContent": "_buttonContent_rbg7a_1",
  "icon": "_icon_rbg7a_1",
  "radio": "_radio_rbg7a_1",
  "item": "_item_rbg7a_1",
  "--item-disabled": "_--item-disabled_rbg7a_1",
  "--item-active": "_--item-active_rbg7a_1",
  "selector": "_selector_rbg7a_1",
  "--selector-hidden": "_--selector-hidden_rbg7a_1",
  "--selector-animated": "_--selector-animated_rbg7a_1",
  "control": "_control_rbg7a_1",
  "control--active": "_control--active_rbg7a_1",
  "control--next": "_control--next_rbg7a_1",
  "control--prev": "_control--prev_rbg7a_1",
  "panel": "_panel_rbg7a_1",
  "--panel-hidden": "_--panel-hidden_rbg7a_1",
  "--scrollable": "_--scrollable_rbg7a_1",
  "--direction-row": "_--direction-row_rbg7a_1",
  "--direction-column": "_--direction-column_rbg7a_1",
  "--variant-borderless": "_--variant-borderless_rbg7a_1",
  "--variant-pills": "_--variant-pills_rbg7a_1",
  "--variant-pills-elevated": "_--variant-pills-elevated_rbg7a_1",
  "--size-medium": "_--size-medium_rbg7a_1",
  "--size-large": "_--size-large_rbg7a_1",
  "--item-width-equal": "_--item-width-equal_rbg7a_1",
  "buttonText": "_buttonText_rbg7a_1",
  "--fade-end": "_--fade-end_rbg7a_1",
  "--fade-start": "_--fade-start_rbg7a_1"
};import "ni:sha-256;-5OKOZ8zHA3Yy8El8NR-W3_AxKsUTNEHLqr-v44R1IE";